export const columnsWrapper = {
	display: 'flex',
	justifyContent: 'space-between',
};

export const linkItemWrapper = {
	display: 'block',
	paddingY: '0.5rem',
};
